import type { Theme } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';

const lightModeTheme: Theme = createTheme({
    palette: {
        primary: {
            main: '#007A8C',
        },
        secondary: {
            main: '#9C27B0',
        },
        error: {
            main: '#D1232C',
        },
        background: {
            default: '#FBFDFF',
            paper: '#F9FAFD',
        },
        text: {
            primary: '#000000',
        },
        divider: '#F3F5F7',
    },
});

export default lightModeTheme;